/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RejectReasonResponse = {
    NoResponseFromClient: 'NO_RESPONSE_FROM_CLIENT',
    TooLate: 'TOO_LATE',
    InternRecruitment: 'INTERN_RECRUITMENT',
    LostToCompetition: 'LOST_TO_COMPETITION',
    AlreadyKnown: 'ALREADY_KNOWN',
    LowBudget: 'LOW_BUDGET',
    NotReferral: 'NOT_REFERRAL',
    CreatedOut: 'CREATED_OUT',
    Other: 'OTHER'
} as const;
export type RejectReasonResponse = typeof RejectReasonResponse[keyof typeof RejectReasonResponse];


export function instanceOfRejectReasonResponse(value: any): boolean {
    for (const key in RejectReasonResponse) {
        if (Object.prototype.hasOwnProperty.call(RejectReasonResponse, key)) {
            // @ts-ignore
            if (RejectReasonResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RejectReasonResponseFromJSON(json: any): RejectReasonResponse {
    return RejectReasonResponseFromJSONTyped(json, false);
}

export function RejectReasonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectReasonResponse {
    return json as RejectReasonResponse;
}

export function RejectReasonResponseToJSON(value?: RejectReasonResponse | null): any {
    return value as any;
}

